import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import CookiesPage from '@/components/pages/CookiesPage'
import LegalPage from '@/components/pages/LegalPage'

import UserLogin from '@/components/users/UserLogin'
import UserAccount from '@/components/users/UserAccount'
import UserForget from '@/components/users/UserForget'
import UserReset from '@/components/users/UserReset'

import SearchList from '@/components/SearchList'
import SearchAdd from '@/components/SearchAdd'
import SearchDetails from '@/components/SearchDetails'
import SearchMembers from '@/components/SearchMembers'
import SearchQueries from '@/components/queries/SearchQueries'
import SearchQueryAdd from '@/components/queries/SearchQueryAdd'
//import SearchQueryUpdate from '@/components/queries/SearchQueryUpdate'
import store from '@/store/store.js'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/users/login',
      name: 'UserLogin',
      component: UserLogin
    },
    {
      path: '/users/account',
      name: 'UserAccount',
      component: UserAccount,
      meta: { requiresAuth: true }
    },
    {
      path: '/users/forget',
      name: 'UserForget',
      component: UserForget,
      meta: { requiresAuth: false }
    },
    {
      path: '/users/resetpassword/:email/:resetToken',
      name: 'UserReset',
      component: UserReset,
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/pages/cookies',
      name: 'CookiesPage',
      component: CookiesPage
    },
    {
      path: '/pages/legal',
      name: 'LegalPage',
      component: LegalPage
    },
    {
      path: '/search/',
      name: 'SearchList',
      component: SearchList,
      meta: { requiresAuth: true }
    },
    {
      path: '/search/add',
      name: 'SearchAdd',
      component: SearchAdd,
      meta: { requiresAuth: true }
    },
    {
      path: '/search/:id',
      name: 'SearchDetails',
      component: SearchDetails,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/search/:id/item/:itemId',
      name: 'SearchDetails',
      component: SearchDetails,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/search/:id/members',
      name: 'SearchMembers',
      component: SearchMembers,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/search/:id/queries',
      name: 'SearchQueries',
      component: SearchQueries,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/search/:id/queries/0',
      name: 'SearchQueryAdd',
      component: SearchQueryAdd,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/search/:searchId/queries/:queryId',
      name: 'SearchQueryUpdate',
      component: SearchQueryAdd,
      props: true,
      meta: { requiresAuth: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    console.log("check token : " + store.getters['getUserToken']);

    if (store.getters['isAuthenticated']){
      // Check the user token if needed
      console.log("actions : ")
      console.log(store.dispatch);
      store.dispatch('checkUserToken').then(() => {
        console.log("token checked")
      });
    }


    // console.log("check authentication : " + store.getters['isAuthenticated']);
    if (!store.getters['isAuthenticated']) {
      console.log("redirect to login page");
      next({
        path: '/users/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js